import { getCategory } from '@/request/OneHubRequest';


async function categoryId2Name(categoryId: string[]) {
  const categoryList = await getCategory();
  return categoryId.map(id => {
    let cat1 = categoryList.find(item => item._id === id);
    if (cat1) return [ cat1.name ];
    cat1 = categoryList.find(item => item.subjectList?.find(sub => sub._id === id));
    if (cat1) return [ cat1.name, cat1.subjectList?.find(sub => sub._id === id)?.name ];
    return [];
  });
}

const btnLink = {
  ios: 'https://ohjcz-alternate.app.link/rpW5987KrSb',
  android: 'https://ohjcz-alternate.app.link/lBPx3e6KrSb',
  mobile: 'https://ohjcz-alternate.app.link/SFhS512KrSb',
  mobileBanner: 'https://ohjcz-alternate.app.link/zwCkM7ZKrSb',
};

export {
  categoryId2Name,
  btnLink,
};
